import { LineItem } from '@pperform/pp-data-mappers';
import { FunctionComponent } from 'preact';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { lineItemTestID } from 'components/MerchantTrackingWidget/constants';
import {
  useFormatItemsCard,
  TruncatedTitle,
  DescriptionWrapper,
  DescriptionColumn,
} from '../../ItemCommons';
import {
  DescriptionLabel,
  DescriptionBody,
  DescriptionHyperLink,
  ReasonForReturnBody,
} from './CardBack.styles';

export interface CardBackProps {
  card: LineItem;
  ariaHidden?: boolean;
}

const CardBack: FunctionComponent<CardBackProps> = ({ card, ariaHidden }) => {
  const {
    productName,
    productDescription,
    productUrl,
    productReasonForReturn,
    productCustomReasonForReturn,
  } = useFormatItemsCard(card);
  const PTPConfig = usePTPConfigContext();
  const lineItemConfig = PTPConfig?.lineItem;
  const {
    productDescription: { showPrice, showQuantity },
  } = lineItemConfig;

  return (
    <DescriptionWrapper aria-hidden={ariaHidden}>
      <DescriptionColumn>
        <TruncatedTitle
          title={productName}
          isShowFull={false}
          data-testid={`${lineItemTestID}-name`}
        >
          {productName}
        </TruncatedTitle>
      </DescriptionColumn>
      <DescriptionColumn>
        {productReasonForReturn && (
          <div data-testid={`${lineItemTestID}-reason-for-return`}>
            <DescriptionLabel isShowFull={false}>
              {productReasonForReturn.label}:
            </DescriptionLabel>
            <ReasonForReturnBody title={productReasonForReturn.value}>
              {productReasonForReturn.value}
            </ReasonForReturnBody>
          </div>
        )}

        {productCustomReasonForReturn && (
          <div data-testid={`${lineItemTestID}-custom-reason-for-return`}>
            <DescriptionLabel isShowFull={false}>
              {productCustomReasonForReturn.label}:
            </DescriptionLabel>
            <ReasonForReturnBody title={productCustomReasonForReturn.value}>
              {productCustomReasonForReturn.value}
            </ReasonForReturnBody>
          </div>
        )}

        {productDescription && (
          <div data-testid={`${lineItemTestID}-description`}>
            <DescriptionLabel isShowFull={false}>
              {productDescription.label}:
            </DescriptionLabel>
            <DescriptionBody
              showReasonForReturn={!!productReasonForReturn?.value}
              showPrice={showPrice}
              showQuantity={showQuantity}
              title={productDescription.value}
            >
              {productDescription.value}
            </DescriptionBody>
          </div>
        )}
        {productUrl && (
          <DescriptionHyperLink
            href={productUrl.value}
            target="_blank"
            tabIndex={ariaHidden ? -1 : 0}
            aria-label={`${productUrl.label} ${productName}`}
            data-testid={`${lineItemTestID}-url`}
          >
            {productUrl.label}
          </DescriptionHyperLink>
        )}
      </DescriptionColumn>
    </DescriptionWrapper>
  );
};

export { CardBack };
